import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import qs from 'qs';
import arrayMove from 'array-move';
import Table from './components/Table'
import NavRoutes from '../../../../components/Navs/NavRoutes';
import { AppearanceContext } from '../../index';
import { getErrorMessage } from '../../../../utils/helper';
import AlertComponent from '../../../../components/Alert';
import PageNotFound from '../../../404';
import {
  languagesEditPosition,
  languagesList,
  languagesToggleVisibility,
} from '../../../../services/endpoints/languages';
import ModalsManager from './components/Modals/Manager';
import Loader from '../../../../components/Loaders/Loader';

const Languages = () => {
  const location = useLocation();

  const { config, menu } = useContext(AppearanceContext);

  const queryString = qs.parse(location.search.slice(1));

  const [init, setInit] = useState(false);
  const [data, setData] = useState({});
  const [error, setError] = useState(null)
  const [tableError, setTableError] = useState(null)
  const [isLoading, setIsLoading] = useState({ page: true, modal: false, table: false });
  const [modal, setModal] = useState({
    openModalKey: null,
    data: {},
  });

  const { languages, available_languages } = data;

  const onHideModals = () => {
    setModal((prevState) => ({
      ...prevState,
      openModalKey: null,
      data: {},
    }))
  };

  const fetchList = async () => {
    setTableError(null)
    setIsLoading((prevState) => ({ ...prevState, table: true }));
    try {
      const response = await languagesList(queryString);
      if (response.success) {
        setData(response.data);
      }
      setIsLoading((prevState) => ({ ...prevState, table: false }));
      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setIsLoading((prevState) => ({ ...prevState, table: false }));
    }
  };

  const getAllData = async () => {
    setIsLoading((prevState) => ({ ...prevState, page: true }));

    try {
      if (config?.access?.languages_list) {
        await fetchList(queryString);
        setIsLoading((prevState) => ({ ...prevState, page: false }));
      } else {
        setIsLoading((prevState) => ({ ...prevState, page: false }));
      }
      setInit(true);
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, page: false }));
    }
  }

  const onChangeVisibility = async (languageCode, visibility) => {
    setData((prevState) => ({
      ...prevState,
      languages: prevState.languages.map((language) => ({
        ...language,
        active: language.code === languageCode ? visibility : language.active,
      })),
    }))

    try {
      await languagesToggleVisibility(languageCode, visibility)
    } catch (error) {
      setData((prevState) => ({
        ...prevState,
        languages: prevState.languages.map((language) => ({
          ...language,
          active: language.code === languageCode ? !visibility : language.active,
        })),
      }))
    }
  }

  const onSort = async ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) {
      return;
    }
    setIsLoading((prevState) => ({ ...prevState, table: true }));
    try {
      const positions = arrayMove(languages, oldIndex, newIndex).map((language, index) => ({
        code: language.code,
        position: index + 1,
      }))
      await languagesEditPosition(positions);
      fetchList()
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setTableError(errorMessage);
      setIsLoading((prevState) => ({ ...prevState, table: false }));
    }
  }

  const onSubmitModal = () => {
    fetchList()
    onHideModals()
  }

  const onOpenModal = (openModalKey, data) => {
    setModal({
      openModalKey,
      data,
    })
  }

  useEffect(() => {
    getAllData()
    document.title = 'Languages';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading.page && !init) {
    return <Loader />;
  }

  if (!config?.access?.languages_list) {
    return <PageNotFound />
  }

  return (
    <Grid>
      <ModalsManager
        modal={modal}
        onHide={onHideModals}
        onSubmit={onSubmitModal}
      />
      <Row>
        <Col md={2} mdOffset={1}>
          <NavRoutes
            routes={menu}
          />
        </Col>
        <Col md={8}>
          <div className="loader-container" style={{ minHeight: '600px' }}>
            {error
              ? <AlertComponent text={error} />
              : (
                <div>
                  {config?.access?.languages_add ? <Button onClick={() => onOpenModal('add', available_languages)} className="m-b">Add new language</Button> : null }
                  {config?.access?.languages_list
                    ? (
                      <div className="m-b languages-table">
                        {tableError ? <AlertComponent text={tableError} /> : null}
                        <Table
                          isLoading={isLoading.table}
                          items={languages}
                          config={config}
                          onSort={onSort}
                          onChangeVisibility={onChangeVisibility}
                        />
                      </div>
                    ) : null }
                </div>
              )}
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

export default Languages;
